"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("../constants/actions/app"));

var remote_item_approve_state_1 = __importDefault(require("../constants/remote-item-approve-state"));

function init() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch, getState) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  dispatch({
                    type: app_1.default.INIT,
                    start_at: Date.now()
                  });
                } catch (error) {
                  dispatch({
                    type: app_1.default.INIT_FAILURE,
                    error: error
                  });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

exports.init = init;

function clearLastError() {
  return function (dispatch, getState) {
    dispatch({
      type: app_1.default.CLEAR_LAST_ERROR
    });
  };
}

exports.clearLastError = clearLastError;

function setGroupSwiped() {
  return function (dispatch, getState) {
    dispatch({
      type: app_1.default.SET_GROUP_SWIPED,
      bool: true
    });
  };
}

exports.setGroupSwiped = setGroupSwiped;

function setItemSwiped() {
  return function (dispatch, getState) {
    dispatch({
      type: app_1.default.SET_ITEM_SWIPED,
      bool: true
    });
  };
}

exports.setItemSwiped = setItemSwiped;

function setForegroundNotification(pushData) {
  return function (dispatch, getState) {
    dispatch({
      type: app_1.default.SET_FOREGROUND_NOTIFICATION,
      data: pushData
    });
  };
}

exports.setForegroundNotification = setForegroundNotification;

function clearForegroundNotification() {
  return function (dispatch, getState) {
    dispatch({
      type: app_1.default.CLEAR_FOREGROUND_NOTIFICATION
    });
  };
}

exports.clearForegroundNotification = clearForegroundNotification;

function clearErrorAndNoti() {
  return function (dispatch, getState) {
    dispatch({
      type: app_1.default.CLEAR_ERROR_NOTI
    });
  };
}

exports.clearErrorAndNoti = clearErrorAndNoti;

function displayGlobalMsg(error) {
  return function (dispatch, getState) {
    dispatch({
      type: app_1.default.SET_LAST_ERROR,
      error: error
    });
  };
}

exports.displayGlobalMsg = displayGlobalMsg;

function onReceiveNotification(data) {
  return function (dispatch, getState) {
    var event = data.event;

    switch (event) {
      case "ITEM_REVIEWED":
        {
          var item_id = data.item_id,
              group_id = data.group_id,
              title = data.title,
              approve_state = data.approve_state;

          if (approve_state === remote_item_approve_state_1.default.APPROVED) {
            dispatch({
              type: app_1.default.ON_NOTI_ITEM_APPROVED,
              item_id: item_id,
              group_id: group_id
            });
          } else if (approve_state === remote_item_approve_state_1.default.REJECTED) {
            dispatch({
              type: app_1.default.ON_NOTI_ITEM_REJECTED,
              item_id: item_id,
              group_id: group_id
            });
          }

          break;
        }
    }
  };
}

exports.onReceiveNotification = onReceiveNotification;